export default __webpack_public_path__ + "static/media/package_8.f5777f89.png";